









































































































































































































































































































































































































































































































































































































































































































































































































































import MarketSelect from '@/components/MarketSelect.vue';
import {Modal} from 'ant-design-vue';
import {GlobalSettingsData, SelectBox, TradingSettingsData} from '@/interfaces/global-data';
import {
  FtpConfigType,
  FtpParameters,
  FtpUsersAndTradings,
  KviSearchMethod,
  MoneyCodes,
  PreCalcStartSettings,
  RevaluationExportFileFormat,
  RevaluationFtpParams,
  SalesLoadingType,
  TradingAndFolderPath,
  TradingAndMoney,
  UpdateFrequency,
  UserPermissions,
} from '@/interfaces/server-data';
import GrabberConfigs from '@/pages/grabber-config/GrabberConfigs.vue';
import {BFormFile} from 'bootstrap-vue';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Http from '../mixins/http';
import LocalData from '../mixins/local-data';
import Card from './UI/Card.vue';
import CollapseCard from './UI/CollapseCard.vue';
import SwitchWithLabel from './UI/SwitchWithLabel.vue';

@Component({
    computed: {
      KviSearchMethod() {
        return KviSearchMethod
      }
    },
    components: {
      MarketSelect,
        GrabberConfigs,
        vSelect,
        DatePicker,
        Card,
        CollapseCard,
        SwitchWithLabel
    },
    methods: {
        replaceDecimalSubStrFormatter(value) {
            if (value == null) {
                return null
            } else {
                const result = parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
                return String(result).substring(0, 6)
                }
            },
        },
        data: {
            selected: [],
        },
    })

    export default class Settings extends Mixins(LocalData, Http) {
        idPreCalcSettings: number = -1;
        startTimePreCalcSettings: string = '';
        mondayPreCalcSettings: boolean = false;
        tuesdayPreCalcSettings: boolean = false;
        wednesdayPreCalcSettings: boolean = false;
        thursdayPreCalcSettings: boolean = false;
        fridayPreCalcSettings: boolean = false;
        saturdayPreCalcSettings: boolean = false;
        sundayPreCalcSettings: boolean = false;
        ftpSendingTime: string | null = null;
        sendToFtpAutomatically: boolean = false;
        isOKRBCodesEnabled: boolean = false;
        sendGeneratedReportNotification: boolean = false;
        serverAddressReports: string = '';
        serverAddressArchive: string = '';
        serverPortReports: number = 21;
        serverPortArchive: number = 21;
        usernameReports: string | null = '';
        usernameArchive: string | null = '';
        passwordReports: string | null = '';
        passwordArchive: string | null = '';
        dataDirectoryReports: string | null = '';
        dataDirectoryArchive: string | null = '';
        tradingArrayForReports: TradingAndFolderPath[] = []
        tradingArrayForArchive: TradingAndFolderPath[] = []
        tradingArrayReportsIsCorrect: boolean = true;
        tradingArrayArchiveIsCorrect: boolean = true;
        typeConfigForReports: string = FtpConfigType.CONFIG_REPORTS_KEY;
        typeConfigForArchive: string = FtpConfigType.CONFIG_ARCHIVE_KEY;
        tradingAndMoneyArray: TradingAndMoney[] = []
        ftpUsersAndTradingsArray: FtpUsersAndTradings[] = []
        operatingExpensesSettings: TradingSettingsData = this.getTradingSettingsDefaultData()
        selectedTradingId: number | null = null;
        currentOperatingExpenses: number = 0;
        tradingAndMoneyArrayIsCorrect: boolean = true;
        settingsIsChanged: boolean = false;
        tradingsList: Array<SelectBox<number>> = [];
        file: File | null = null;
        loadProgress: boolean = false;
        progressCounter: number = 0;
        updateFrequencyValue: number = 0;
        // Loading states for save buttons
        isLoadingFtpReports: boolean = false;
        isLoadingFtpArchive: boolean = false;
        isLoadingTradingMoney: boolean = false;
        isLoadingRevaluation: boolean = false;
        isLoadingTwoStepApproval: boolean = false;
        isLoadingPreCalc: boolean = false;
        isLoadingUpdateFrequency: boolean = false;
        isLoadingOKRB: boolean = false;
        isLoadingOperatingExpenses: boolean = false;
        isLoadingGlobalSettings: boolean = false;
        isLoadingFtpUsers: boolean = false;
        // Individual loading states for global settings buttons
        isLoadingClearCache: boolean = false;
        isLoadingGlobalSettingsButtons: { [key: string]: boolean } = {
            salePointsDirectory: false,
            assortmentDirectory: false,
            competitorsDirectory: false,
            productLineDirectory: false,
            kviSearchMethod: false,
            approvalPeriod: false,
            rtnDocument: false,
            sendRevaluationOnlyForChangedPrices: false,
            useSaleStatus: false,
            twoStepApproval: false,
            revaluationStartDateOffset: false,
            excludeZeroRemains: false
        };
        defaultTradingNetwork: number = -1;
        tradingNetworksOptions: Array<SelectBox<number>> = [{value: -1, label: this.$t('shared.selectBox.notSelected') as string}];
        kviSearchMethodsOptions: Array<SelectBox<KviSearchMethod>> = [
            {value: KviSearchMethod.ML, label: this.$t('settings.kviMethods.ml') as string},
            {value: KviSearchMethod.CLUSTERIZATION, label: this.$t('settings.kviMethods.clusterization') as string}
        ];
        globalSettings: GlobalSettingsData = this.getGlobalSettingsDefaultData();

        moneyCodesList: Array<SelectBox<MoneyCodes | null>> = [
            {value: MoneyCodes.RUB, label: this.$t('settings.currencies.RUB') as string},
            {value: MoneyCodes.USD, label: this.$t('settings.currencies.USD') as string},
            {value: MoneyCodes.EUR, label: this.$t('settings.currencies.EUR') as string},
            {value: MoneyCodes.KZT, label: this.$t('settings.currencies.KZT') as string},
            {value: MoneyCodes.BYN, label: this.$t('settings.currencies.BYN') as string},
            {value: MoneyCodes.UAH, label: this.$t('settings.currencies.UAH') as string},
            {value: MoneyCodes.UZS, label: this.$t('settings.currencies.UZS') as string},
            {value: MoneyCodes.CAD, label: this.$t('settings.currencies.CAD') as string},
            {value: MoneyCodes.GBP, label: this.$t('settings.currencies.GBP') as string},
            {value: MoneyCodes.BRL, label: this.$t('settings.currencies.BRL') as string},
            {value: MoneyCodes.CNY, label: this.$t('settings.currencies.CNY') as string},
        ];

    updateFrequencyList: Array<SelectBox<UpdateFrequency | null>> = [
        {value: UpdateFrequency.ONE, label: this.$t('settings.updateFrequencies.oneMinute') as string},
        {value: UpdateFrequency.FIVE, label: this.$t('settings.updateFrequencies.fiveMinutes') as string},
        {value: UpdateFrequency.TEN, label: this.$t('settings.updateFrequencies.tenMinutes') as string},
        {value: UpdateFrequency.THIRTY, label: this.$t('settings.updateFrequencies.thirtyMinutes') as string},
    ];

    salesLoadingTypeList: Array<SelectBox<SalesLoadingType | null>> = [
      {value: SalesLoadingType.RECEIPTS_SEPARATELY, label: this.$t('settings.salesLoadingTypes.receiptsSeparately') as string},
      {value: SalesLoadingType.AGGREGATE_BY_SKU, label: this.$t('settings.salesLoadingTypes.aggregateBySku') as string},
    ];

        selectMoneyCode: SelectBox<MoneyCodes> = {value: MoneyCodes.RUB, label: this.$t('settings.currencies.RUB') as string};

        onMainTabsClicked(key: any){
            if(key === "main"){
                this.tryDownloadMoneyAndRevaluationsParameters()
            }
            if(key === "FTP"){
                this.tryDownloadFtpUsersAndTradingsParameters()
            }
        }

        clearCache() {
            Modal.confirm({
                title: this.$t('settings.main.resetCache') as string,
                content: this.$t('settings.messages.cacheResetConfirm') as string,
                centered: true,
                okText: this.$t('settings.main.resetCache') as string,
                cancelText: this.$t('shared.actions.cancel') as string,
                onOk: () => {
                    return this.performCacheClear();
                },
            });
        }

        private async performCacheClear() {
            this.isLoadingClearCache = true;
            try {
                if ('serviceWorker' in navigator) {
                    const registrations = await navigator.serviceWorker.getRegistrations();
                    await Promise.all(registrations.map((r) => r.unregister()));
                }
                if ('caches' in window) {
                    const cacheNames = await caches.keys();
                    await Promise.all(cacheNames.map((name) => caches.delete(name)));
                }
                if (typeof performance !== 'undefined' && performance.getEntriesByType) {
                    const resources = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
                    const seen = new Set<string>();
                    const refetchPromises: Array<Promise<void>> = [];
                    for (const entry of resources) {
                        if (seen.has(entry.name)) continue;
                        seen.add(entry.name);
                        try {
                            const resourceUrl = new URL(entry.name);
                            if (resourceUrl.origin === window.location.origin) {
                                refetchPromises.push(
                                    fetch(entry.name, { cache: 'reload' }).then(() => undefined).catch(() => undefined)
                                );
                            }
                        } catch (_) { /* skip invalid URLs */ }
                    }
                    await Promise.all(refetchPromises);
                }
                this.showInfo(this.$t('settings.messages.cacheResetSuccess') as string);
                const url = new URL(window.location.href);
                url.searchParams.set('_cache_bust', String(Date.now()));
                setTimeout(() => {
                    window.location.href = url.toString();
                }, 2000);
            } catch (err) {
                console.error('Cache reset error:', err);
                this.showError(this.$t('settings.messages.cacheResetError') as string);
                this.isLoadingClearCache = false;
            }
        }

        downloadHintsFile() {
            this.$http.get('/api/file/download-hints-file', {
                method: 'GET',
                responseType: 'blob',
            })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Hints.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((e) => {
                        this.showError(this.$t('settings.messages.hintsDownloadError') as string);
                    });
        }

        uploadHintsFile(event: Event) {
            event.preventDefault();
            if (!this.file) {
                this.showInfo(this.$t('settings.messages.selectFile') as string);
                return;
            }

            const uploadFile = new FormData();
            this.loadProgress = true;
            const size = this.file.size;
            uploadFile.append('file', new Blob([this.file]), this.file.name);
            const self = this;
            const onUploadProgress = (e: any) => {
                const s = e.loaded / size;
                self.progressCounter = (s * 100) > 100 ? 100 : Math.round(s * 100);
            };

            this.httpUploadHintsFile(uploadFile, onUploadProgress)
                    .then(() => {
                        (this.$refs.fileinput as BFormFile).reset();
                        this.file = null;
                        (this.$refs.filesTable as any).refresh();
                        this.$nextTick(() => {
                            this.loadProgress = false;
                            this.progressCounter = 0;
                        });
                    })
                    .catch((e) => {
                        // this.showError(this.$t('settings.errors.uploadFile') as string);
                        this.loadProgress = false;
                        this.progressCounter = 0;
                        this.file = null;
                        (this.$refs.fileinput as BFormFile).reset();
                    });

        }

        get reportsParamsIsNotValidate(): boolean {
            if (this.serverAddressReports.trim() === '' || this.serverPortReports <= 0
                || this.usernameReports == null || this.usernameReports.trim() === ''
                || this.passwordReports == null || this.passwordReports.trim() === ''
                || this.dataDirectoryReports == null || this.dataDirectoryReports.trim() === ''
            ) {
                return true
            }
            const counter: { [key: number]: number } = {};
            const invalidItem = this.tradingArrayForReports.findIndex((item) => {
                    if (item.trId != null && item.trId > 0) {
                        if (counter.hasOwnProperty(item.trId)) {
                            counter[item.trId] = counter[item.trId] + 1
                        } else {
                            counter[item.trId] = 1
                        }
                    }
                    return item.trId == null || item.trId <= 0 || item.dataDirectory == null || item.dataDirectory.trim() === ''
                },
            )

            for (const key in counter) {
                if (counter[key] > 1) {
                    return true
                }
            }
            return invalidItem !== -1;
        }

        get archiveParamsIsNotValidate(): boolean {
            if (this.serverAddressArchive.trim() === '' || this.serverPortArchive <= 0
                || this.usernameArchive == null || this.usernameArchive.trim() === ''
                || this.passwordArchive == null || this.passwordArchive.trim() === ''
                || this.dataDirectoryArchive == null || this.dataDirectoryArchive.trim() === ''
            ) {
                return true
            }
            const counter: { [key: number]: number } = {};
            const invalidItem = this.tradingArrayForArchive.findIndex((item) => {
                    if (item.trId != null && item.trId > 0) {
                        if (counter.hasOwnProperty(item.trId)) {
                            counter[item.trId] = counter[item.trId] + 1
                        } else {
                            counter[item.trId] = 1
                        }
                    }
                    return item.trId == null || item.trId <= 0 || item.dataDirectory == null || item.dataDirectory.trim() === ''
                },
            )

            for (const key in counter) {
                if (counter[key] > 1) {
                    return true
                }
            }
            return invalidItem !== -1;
        }

        get paramsTrAndMoneyIsNotValidate(): boolean {
            const counter: { [key: number]: number } = {};
            const invalidItem = this.tradingAndMoneyArray.findIndex((item) => {
                    if (item.trId != null && item.trId > 0) {
                        if (counter.hasOwnProperty(item.trId)) {
                            counter[item.trId] = counter[item.trId] + 1
                        } else {
                            counter[item.trId] = 1
                        }
                    }
                    return item.trId == null || item.trId <= 0
                },
            )

            for (const key in counter) {
                if (counter[key] > 1) {
                    return true
                }
            }
            return invalidItem !== -1;
        }

        tryFindFtpParameters() {
            this.httpGetFtpParameters()
                .then((r) => {
                        if (r.status === 200) {
                            const reportsParams = r.data.baseParams
                            if (reportsParams != null) {
                                this.serverAddressReports = reportsParams.serverAddress
                                this.serverPortReports = reportsParams.serverPort
                                this.usernameReports = reportsParams.username
                                this.passwordReports = reportsParams.password
                                this.dataDirectoryReports = reportsParams.dataDirectory
                                if (reportsParams.tradingCompaniesFileTransferSettings != null) {
                                    this.tradingArrayForReports =
                                        reportsParams.tradingCompaniesFileTransferSettings.map((i) => {
                                            return {
                                                trId: i.trId,
                                                serverAddress: i.serverAddress,
                                                serverPort: i.serverPort,
                                                username: i.username,
                                                password: i.password,
                                                rollingUpChecks: i.rollingUpChecks != null ? i.rollingUpChecks : (SalesLoadingType.RECEIPTS_SEPARATELY as string),
                                                dataDirectory: i.dataDirectory,
                                            };
                                        });
                                }
                            }

                            if (r.data.archiveParams != null) {
                                const archiveParams = r.data.archiveParams
                                this.serverAddressArchive = archiveParams.serverAddress
                                this.serverPortArchive = archiveParams.serverPort
                                this.usernameArchive = archiveParams.username
                                this.passwordArchive = archiveParams.password
                                this.dataDirectoryArchive = archiveParams.dataDirectory
                                if (archiveParams.tradingCompaniesFileTransferSettings != null) {
                                    this.tradingArrayForArchive =
                                        archiveParams.tradingCompaniesFileTransferSettings.map((i) => {
                                            return {
                                                trId: i.trId,
                                                serverAddress: i.serverAddress,
                                                serverPort: i.serverPort,
                                                username: i.username,
                                                password: i.password,
                                                rollingUpChecks: i.rollingUpChecks != null ? i.rollingUpChecks : (SalesLoadingType.RECEIPTS_SEPARATELY as string),
                                                dataDirectory: i.dataDirectory,
                                            };
                                        });
                                }
                            }
                        }
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.ftpParamsError') as string);
                });
        }

        downloadPreCalcSettings() {
            this.httpGetPreCalcSettings()
                    .then((r) => {
                                this.idPreCalcSettings = r.data.id
                                this.startTimePreCalcSettings = r.data.startTimePreCalcSettings
                                this.mondayPreCalcSettings = r.data.mondayPreCalcSettings
                                this.tuesdayPreCalcSettings = r.data.tuesdayPreCalcSettings
                                this.wednesdayPreCalcSettings = r.data.wednesdayPreCalcSettings
                                this.thursdayPreCalcSettings = r.data.thursdayPreCalcSettings
                                this.fridayPreCalcSettings = r.data.fridayPreCalcSettings
                                this.saturdayPreCalcSettings = r.data.saturdayPreCalcSettings
                                this.sundayPreCalcSettings = r.data.sundayPreCalcSettings
                            },
                    )
                    .catch((e) => {
                        this.showError(this.$t('settings.messages.preCalcSettingsError') as string);
                    });
        }

        tryDownloadMoneyAndRevaluationsParameters() {
            this.httpGetMoneyCodes()
                .then((r) => {
                        if (r.status === 200) {
                            this.tradingAndMoneyArray = r.data
                        }
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.moneyCodesError') as string);
                });
            this.getFtpRevaluationsParams()
            this.getIsOKRBCodesEnabled()
        }

        tryDownloadFtpUsersAndTradingsParameters() {
            this.httpGetFtpUsersAndTradings()
                .then((r) => {
                        if (r.status === 200) {
                            this.ftpUsersAndTradingsArray = r.data
                        }
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.ftpUsersError') as string);
                });
        }

        getFtpRevaluationsParams() {
            this.httpGetFtpRevaluationsParams()
                .then((r) => {
                        this.ftpSendingTime = r.data.ftpSendingTime;
                        this.sendToFtpAutomatically = r.data.sendRevaluationAutomatically
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.ftpRevaluationsError') as string);
                });
        }

        getIsOKRBCodesEnabled() {
            this.isOKRBCodesEnabled = localStorage.getItem('isOKRBCodesEnabled') === 'true'
        }

        loadAllTradingNames() {
            this.httpLoadTradingNetworks()
                .then((result) => {
                        this.tradingsList = result.data.map((market) => {
                            return {value: market.id, label: market.tradingName};
                        });
                        this.tradingNetworksOptions = [{value: -1, label: this.$t('shared.selectBox.notSelected') as string}];
                        this.tradingNetworksOptions.push(...this.tradingsList)
                        const foundDefaultTradingNetwork = result.data.find((i) => i.isDefault)
                        if (foundDefaultTradingNetwork) {
                          this.defaultTradingNetwork = foundDefaultTradingNetwork.id
                        }
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.tradingNetworksError') as string);
                });
        }

        saveFtpParametersForReports() {
            this.isLoadingFtpReports = true;
            const ftpParameters = this.ftpParamsForReports();
            this.httpSaveFtpParameters(ftpParameters)
                .then((r) => {
                        this.showInfo(this.$t('settings.messages.ftpReportsSaved') as string);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.ftpReportsSaveError') as string);
                })
                .finally(() => {
                    this.isLoadingFtpReports = false;
                });
        }

        saveFtpParametersForArchive() {
            this.isLoadingFtpArchive = true;
            const ftpParameters = this.ftpParamsForArchive();
            this.httpSaveFtpParameters(ftpParameters)
                .then((r) => {
                        this.showInfo(this.$t('settings.messages.ftpArchiveSaved') as string);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.ftpArchiveSaveError') as string);
                })
                .finally(() => {
                    this.isLoadingFtpArchive = false;
                });
        }

        saveFilter() {
            localStorage.setItem('sendGeneratedReportNotification', this.sendGeneratedReportNotification.toString())
        }

        saveTradingsAndMoneyCodesParameters() {
            this.isLoadingTradingMoney = true;
            this.httpSaveMoneyCodes(this.tradingAndMoneyArray)
                .then((r) => {
                        this.showInfo(this.$t('settings.messages.moneyCodesSaved') as string);
                        this.settingsIsChanged = false;
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.moneyCodesSaveError') as string);
                })
                .finally(() => {
                    this.isLoadingTradingMoney = false;
                });
        }

        saveFtpUsersAndTradingsParameters() {
            this.isLoadingFtpUsers = true;
            this.httpSaveFtpUsersAndTradings(this.ftpUsersAndTradingsArray)
                .then((r) => {
                        this.ftpUsersAndTradingsArray.forEach((item) => {
                           item.editable = false;
                        });
                        this.showInfo(this.$t('settings.messages.ftpUsersSaved') as string);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.ftpUsersSaveError') as string);
                })
                .finally(() => {
                    this.isLoadingFtpUsers = false;
                });
        }

        saveDefaultTradingNetwork(tradingNetworkId: number | null) {
            if (tradingNetworkId && tradingNetworkId !== -1) {
              this.defaultTradingNetwork = tradingNetworkId
              this.httpSaveDefaultTradingNetwork(tradingNetworkId)
                  .then((r) => {
                        this.showInfo(this.$t('settings.messages.defaultTradingSaved') as string);
                      },
                  )
                  .catch((e) => {
                    this.showError(this.$t('settings.messages.defaultTradingSaveError') as string);
                  });
            }
        }

        addTradingAndPathToReportsArray() {
            this.tradingArrayForReports.push({trId: null, dataDirectory: null, serverAddress: '', serverPort: 21, username: null, password: null, rollingUpChecks: SalesLoadingType.RECEIPTS_SEPARATELY as string});
        }

        addTradingAndPathToArchiveArray() {
            this.tradingArrayForArchive.push({trId: null, dataDirectory: null, serverAddress: '', serverPort: 21, username: null, password: null, rollingUpChecks: SalesLoadingType.RECEIPTS_SEPARATELY as string});
        }

        addTradingAndMoneyCodeToArray() {
            this.settingsIsChanged = true
            this.tradingAndMoneyArray.push({trId: null, moneyCode: MoneyCodes.RUB});
        }

        addFtpUserAndTradingsToArray() {
            this.ftpUsersAndTradingsArray.push({userName: null, editable: true, tradingIds: []});
        }

        removeReportsTradingNet(index: number) {
            this.tradingArrayForReports.splice(index, 1);
        }

        removeArchiveTradingNet(index: number) {
            this.tradingArrayForArchive.splice(index, 1);
        }

        removeFromFtpUserToTradings(index: number) {
            this.ftpUsersAndTradingsArray.splice(index, 1);
        }

        isSelectedTrading(tableRow: FtpUsersAndTradings, tradingId: number): boolean {
            const index = tableRow.tradingIds.findIndex((item) => {
                return item === tradingId
            });
            return index !== -1;
        }

        setSelectedTrading(tradingId: number, tableIndex: number, change: boolean) {
            if (change) {
                this.ftpUsersAndTradingsArray[tableIndex].tradingIds.push(tradingId)
            } else {
                const index = this.ftpUsersAndTradingsArray[tableIndex].tradingIds.findIndex((item) => {
                    return item === tradingId
                });
                if (index !== -1) {
                    this.ftpUsersAndTradingsArray[tableIndex].tradingIds.splice(index, 1)
                }
            }
        }

        removeTradingNetFromTrAndMoneyArray(index: number) {
            this.settingsIsChanged = true
            this.tradingAndMoneyArray.splice(index, 1);
        }

        makeSaveButtonActiveWhenChanging() {
            this.settingsIsChanged = true
        }

        updateFrequency() {
        }

        resetFtpParameters(configName: string) {
            if (confirm(this.$t('settings.messages.resetConfirm') as string)) {
                this.httpResetFtpParameters(configName)
                    .then((r) => {
                            if (configName === FtpConfigType.CONFIG_REPORTS_KEY) {
                                this.serverAddressReports = '';
                                this.serverPortReports = 21;
                                this.usernameReports = '';
                                this.passwordReports = '';
                                this.dataDirectoryReports = '';
                                this.tradingArrayForReports = [];
                            } else {
                                this.serverAddressArchive = '';
                                this.serverPortArchive = 21;
                                this.usernameArchive = '';
                                this.passwordArchive = '';
                                this.dataDirectoryArchive = '';
                                this.tradingArrayForArchive = [];
                            }
                        },
                    )
                    .catch((e) => {
                        this.showError(this.$t('settings.messages.ftpResetError') as string);
                    });
            }
        }

        disableReportsSaveButton(): boolean {
            if (this.tradingArrayForReports.length > 0) {
                this.checkTradingReportsArrayOnCorrectRows();
                return (!this.serverAddressValidate(this.serverAddressReports) || !this.serverPortValidate(this.serverPortReports)) || this.reportsParamsIsNotValidate || !this.tradingArrayReportsIsCorrect;
            } else {
                return (!this.serverAddressValidate(this.serverAddressReports) || !this.serverPortValidate(this.serverPortReports)) || this.reportsParamsIsNotValidate;
            }
        }

        disableArchiveSaveButton(): boolean {
            if (this.tradingArrayForArchive.length > 0) {
                this.checkTradingArchiveArrayOnCorrectRows();
                return !this.serverAddressValidate(this.serverAddressArchive) || !this.serverPortValidate(this.serverPortArchive) || this.archiveParamsIsNotValidate || !this.tradingArrayArchiveIsCorrect;
            } else {
                return !this.serverAddressValidate(this.serverAddressArchive) || !this.serverPortValidate(this.serverPortArchive) || this.archiveParamsIsNotValidate;
            }
        }

        disableTrAndMoneySaveButton(): boolean {
            if (this.tradingAndMoneyArray.length > 0) {
                this.checkTradingAndMoneyArrayOnCorrectRows();
                return this.paramsTrAndMoneyIsNotValidate || !this.tradingAndMoneyArrayIsCorrect || !this.settingsIsChanged;
            } else {
                return !this.settingsIsChanged;
            }
        }

        disableFtpUsersAndTradingSaveButton(): boolean {
            const index = this.ftpUsersAndTradingsArray.findIndex((ftpUserParam) => {
                return ftpUserParam.userName === null || ftpUserParam.userName === '' || ftpUserParam.tradingIds.length === 0
            });

            const counter: { [key: string]: number } = {};
            this.ftpUsersAndTradingsArray.forEach((item) => {
                if (item.userName != null) {
                    if (counter.hasOwnProperty(item.userName)) {
                        counter[item.userName] = counter[item.userName] + 1
                    } else {
                        counter[item.userName] = 1
                    }
                }

            });
            let findCounter = false
            for (const key in counter) {
                if (counter[key] > 1) {
                    findCounter = true
                    this.showError(this.$t('settings.messages.userAlreadyExists', { name: key }) as string)
                }
            }
            return index !== -1 || findCounter;
        }

        disableRevaluationParamsSaveButton(): boolean {
            return this.sendToFtpAutomatically && this.ftpSendingTime == null
        }

        disableUsePurchasePriceFromAssortmentDirectory(): boolean {
          return !this.globalSettings.useAssortmentDirectory
        }

        disableUseStatusFromAssortmentDirectory(): boolean {
          return !this.globalSettings.useAssortmentDirectory
        }

        changePurchasePriceCheckbox() {
          if (!this.globalSettings.useAssortmentDirectory) {
            this.globalSettings.usePurchasePriceFromAssortmentDirectory = false
            this.globalSettings.useStatusFromAssortmentDirectory = false
          }
        }

        onOperatingExpensesNetworkSelect(tradingId: number) {
          this.fetchOperatingExpensesSettingData(tradingId)
          this.currentOperatingExpenses = this.operatingExpensesSettings.operatingExpenses;
        }

        saveOperatingExpensesParams() {
          if (!this.selectedTradingId || this.selectedTradingId === -1) {
            this.showError(this.$t('settings.messages.selectTradingNetworkBeforeSave') as string);
            return;
          }
          this.isLoadingOperatingExpenses = true;
          const tradingId = this.selectedTradingId;

          this.httpGetTradingSettings(tradingId)
              .then((r) => {
                const params: TradingSettingsData = {
                  ...r.data,
                  operatingExpenses: this.currentOperatingExpenses,
                };
                return this.httpSaveOperatingExpensesSettings(params, tradingId);
              })
              .then(() => {
                this.operatingExpensesSettings.operatingExpenses = this.currentOperatingExpenses;
                this.showInfo(this.$t('settings.messages.operatingExpensesSaved') as string);
              })
              .catch(() => {
                this.showError(this.$t('settings.messages.operatingExpensesSaveError') as string);
              })
              .finally(() => {
                this.isLoadingOperatingExpenses = false;
              });
        }

        fetchOperatingExpensesSettingData(tradingId: number) {
          this.httpGetTradingSettings(tradingId)
              .then((r) => {
                this.operatingExpensesSettings = r.data;
                this.currentOperatingExpenses = this.operatingExpensesSettings.operatingExpenses;
              })
              .catch((ex) => {
                this.showError(this.$t('settings.messages.operatingExpensesLoadError') as string)
              })
        }

        saveRevaluationParams() {
            this.isLoadingRevaluation = true;
            const params: RevaluationFtpParams = {
                sendRevaluationAutomatically: this.sendToFtpAutomatically,
                ftpSendingTime: this.ftpSendingTime,
            }
            this.httpSaveFtpRevaluationParams(params)
                .then((r) => {
                        this.getFtpRevaluationsParams();
                        this.showInfo(this.$t('settings.messages.revaluationParamsSaved') as string);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('settings.messages.revaluationParamsSaveError') as string);
                })
                .finally(() => {
                    this.isLoadingRevaluation = false;
                });
        }

        savePreCalcStartParams() {
            this.isLoadingPreCalc = true;
            const params: PreCalcStartSettings = {
                id: this.idPreCalcSettings,
                startTimePreCalcSettings: this.startTimePreCalcSettings,
                mondayPreCalcSettings: this.mondayPreCalcSettings,
                tuesdayPreCalcSettings: this.tuesdayPreCalcSettings,
                wednesdayPreCalcSettings: this.wednesdayPreCalcSettings,
                thursdayPreCalcSettings: this.thursdayPreCalcSettings,
                fridayPreCalcSettings: this.fridayPreCalcSettings,
                saturdayPreCalcSettings: this.saturdayPreCalcSettings,
                sundayPreCalcSettings: this.sundayPreCalcSettings,
            }
            this.httpSavePreCalcStartParams(params)
                    .then((r) => {
                                this.showInfo(this.$t('settings.messages.preCalcParamsSaved') as string);
                            },
                    )
                    .catch((e) => {
                        this.showError(this.$t('settings.messages.preCalcParamsSaveError') as string);
                    })
                    .finally(() => {
                        this.isLoadingPreCalc = false;
                    });
        }

        saveUpdateFrequencyParams() {
            this.isLoadingUpdateFrequency = true;
            try {
                localStorage.setItem('updateFrequency', this.updateFrequencyValue.toString());
                localStorage.setItem('hasSetUpdateFrequency', 'true');
                this.showInfo(this.$t('settings.messages.updateFrequencySaved') as string);
            } catch (error) {
                this.showError(this.$t('settings.messages.updateFrequencySaveError') as string);
            } finally {
                this.isLoadingUpdateFrequency = false;
            }
        }

    saveUpdateOKRBCodesEnable() {
        this.isLoadingOKRB = true;
        let permissionsUpdated = this.$permissions
        if (this.isOKRBCodesEnabled) {
            if (!permissionsUpdated.includes('OKRB_CODES')) {
                permissionsUpdated.push('OKRB_CODES');
            }
        } else {
            permissionsUpdated = permissionsUpdated.filter((item) => item !== 'OKRB_CODES');
        }
        const userPermissions: UserPermissions = {
            accessToSystemParams: this.$accessToSystemParams,
            permissions: permissionsUpdated,
        };
        this.httpChangeUserPermissions(this.$userId, userPermissions)
            .then(() => {
                localStorage.setItem('isOKRBCodesEnabled', String(this.isOKRBCodesEnabled));
                this.showInfo(this.$t('settings.messages.okrbCodesSaved') as string);
            }).catch((e) => {
            if (e.response.status === 404) {
                (this.$refs.changeUserSystemAccess as any).hide();
                this.showError(this.$t('settings.messages.userNotFound') as string);
            } else {
                this.showError(this.$t('settings.messages.userSettingsError') as string);
            }
        }).finally(() => {
            this.isLoadingOKRB = false;
        });
    }

        fetchGlobalSettingsData() {
          this.httpGetGlobalSettings()
              .then((r) => {
                this.globalSettings = r.data;
              })
              .catch((ex) => {
                this.showError(this.$t('settings.messages.globalSettingsLoadError') as string)
              })
        }

        saveGlobalSettings(buttonId?: string) {
          // If buttonId is provided, use individual loading state, otherwise use global
          if (buttonId) {
            this.isLoadingGlobalSettingsButtons[buttonId] = true;
          } else {
            this.isLoadingGlobalSettings = true;
          }

          const o = this.globalSettings.revaluationStartDateOffsetDays;
          if (typeof o === 'number' && isNaN(o)) {
            this.globalSettings.revaluationStartDateOffsetDays = null;
          }

          this.httpSaveGlobalSettings(this.globalSettings)
              .then((r) => {
                this.globalSettings = r.data;
                this.showInfo(this.$t('settings.messages.globalSettingsSaved') as string)
              })
              .catch((error) => {
                this.showError(this.$t('settings.messages.globalSettingsSaveError') as string);
              })
              .finally(() => {
                if (buttonId) {
                  this.isLoadingGlobalSettingsButtons[buttonId] = false;
                } else {
                  this.isLoadingGlobalSettings = false;
                }
              });
        }

        checkTradingReportsArrayOnCorrectRows() {
            const indexCategory = this.tradingArrayForReports.findIndex((item) => {
                return item.trId == null || item.trId <= 0 || item.serverAddress === '' || isNaN(item.serverPort)
            });
            this.tradingArrayReportsIsCorrect = indexCategory === -1;
        }

        checkTradingArchiveArrayOnCorrectRows() {
            const indexCategory = this.tradingArrayForArchive.findIndex((item) => {
                return item.trId == null || item.trId <= 0 || item.serverAddress === '' || isNaN(item.serverPort)
            });
            this.tradingArrayArchiveIsCorrect = indexCategory === -1;
        }

        checkTradingAndMoneyArrayOnCorrectRows() {
            const index = this.tradingAndMoneyArray.findIndex((item) => {
                return item.trId == null || item.trId <= 0
            });
            this.tradingAndMoneyArrayIsCorrect = index === -1;
        }

        mounted() {
            const url = new URL(window.location.href);

            if (url.searchParams.has('_cache_bust')) {
                url.searchParams.delete('_cache_bust');
                window.history.replaceState({}, '', url.toString());
            }

            this.tryFindFtpParameters();
            this.loadAllTradingNames();
            this.downloadPreCalcSettings();
            this.updateFrequencyValue = parseInt(localStorage.getItem('updateFrequency') || '0', 10);
            this.fetchGlobalSettingsData()
        }

        serverAddressValidate(serverAddress: string): boolean {
            const result = serverAddress.trim();
            return result != null && result !== '';
        }

        serverPortValidate(serverPort: number): boolean {
            return !isNaN(serverPort) && serverPort > 0;
        }

        private ftpParamsForReports(): FtpParameters {
            return {
                serverAddress: this.serverAddressReports,
                serverPort: this.serverPortReports,
                username: this.usernameReports,
                password: this.passwordReports,
                dataDirectory: this.dataDirectoryReports,
                tradingCompaniesFileTransferSettings: this.tradingArrayForReports,
                configType: this.typeConfigForReports,
            };
        }

        private ftpParamsForArchive(): FtpParameters {
            return {
                serverAddress: this.serverAddressArchive,
                serverPort: this.serverPortArchive,
                username: this.usernameArchive,
                password: this.passwordArchive,
                dataDirectory: this.dataDirectoryArchive,
                tradingCompaniesFileTransferSettings: this.tradingArrayForArchive,
                configType: this.typeConfigForArchive,
            };
        }
    }
